import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "services/api";

export const fetchMeatComplaianceSummary = createAsyncThunk(
  "sensorData/fetchMeatComplaianceSummary",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/metrics/meat/compliance-summary/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchMeatComplianceTrends = createAsyncThunk(
  "sensorData/fetchMeatComplianceTrends",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/metrics/meat/compliance-trends/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchMEATComplianceDistribution = createAsyncThunk(
  "sensorData/fetchMEATComplianceDistribution",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/metrics/meat/compliance-distribution/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchNonCompliantHCC = createAsyncThunk(
  "sensorData/fetchNonCompliantHCC",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/metrics/meat/non-compliant-hccs/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchMeatNonComplianceReport = createAsyncThunk(
  "sensorData/fetchMeatNonComplianceReport",
  async (
    {
      startDate,
      endDate,
      userOrganization,
      reportType,
      ordering,
      search,
      patient,
      rendering_provider,
      overall_compliance,
      page = 1,
      pageSize = 10,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`v1/progress-notes/meat`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        report_type: reportType,
        page: page,
        page_size: pageSize,
        ordering: ordering,
        search: search,
        patient: patient,
        overall_compliance: overall_compliance,
        rendering_provider: rendering_provider,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchRenderingProvidersList = createAsyncThunk(
  "sensorData/fetchRenderingProviders",
  async ({ userOrganization, search, page = 1, pageSize = 10 }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/progress-notes/rendering-providers/`,
      {
        params: {
          page: page,
          page_size: pageSize,
          search: search,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const getRenderingProviderDetails = createAsyncThunk(
  "sensorData/getRenderingProviderDetails",
  async ({ userOrganization, renderingProviderId }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/progress-notes/rendering-providers/${renderingProviderId}/`,
      {
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
export const fetchPatientsList = createAsyncThunk(
  "sensorData/fetchPatientsList",
  async ({ userOrganization, search, page = 1, pageSize = 10 }, thunkAPI) => {
    const response = await apiRequest.get(`v1/progress-notes/patients/`, {
      params: {
        page: page,
        page_size: pageSize,
        search: search,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
export const listClinitianMeatCompliance = createAsyncThunk(
  "sensorData/clinitianMeatComplianceList",
  async (
    {
      userOrganization,
      search,
      startDate,
      endDate,
      rendering_provider,
      clinic,
      page = 1,
      pageSize = 10,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(
      `v1/progress-notes/rendering-providers/meat-compliance-report/`,
      {
        params: {
          page: page,
          page_size: pageSize,
          search: search,
          service_start_date: startDate,
          service_end_date: endDate,
          rendering_provider: rendering_provider,
          clinic: clinic,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
export const fetchProgressNoteAnalysis = createAsyncThunk(
  "sensorData/fetchProgressNoteAnalysis",
  async (
    {
      status,
      patient,
      rendering_provider,
      service_date_start,
      service_date_end,
      ordering,
      page = 1,
      pageSize = 10,
      userOrganization,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`v1/progress-notes/meat/`, {
      params: {
        overall_compliance: status,
        patient: patient,
        rendering_provider: rendering_provider,
        start_date: service_date_start ? service_date_start.split("T")[0] : "",
        end_date: service_date_end ? service_date_end.split("T")[0] : "",
        ordering: ordering,
        page: page,
        page_size: pageSize,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });

    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchProgressNoteAnalysisDetails = createAsyncThunk(
  "sensorData/fetchProgressNoteAnalysisDetails",
  async ({ id, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(`v1/progress-notes/meat/${id}/`, {
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchProgressNoteMEATDetails = createAsyncThunk(
  "sensorData/fetchProgressNoteMEATDetails",
  async ({ id, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/progress-notes/${id}/meat-analysis/`,
      {
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
export const fetchHCCCategoriesCompliance = createAsyncThunk(
  "sensorData/fetchHCCCategoriesCompliance",
  async (
    {
      startDate,
      endDate,
      userOrganization,
      hccCategory,
      hccNumber,
      ordering,
      page = 1,
      pageSize = 10,
    },
    thunkAPI
  ) => {
    try {
      const response = await apiRequest.get(
        `v1/meat/condition-analysis/hcc-category-compliance/`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
            hcc_condition__category__category_id: hccCategory,
            hcc_condition__category__hcc_number: hccNumber,
            ordering,
            page,
            page_size: pageSize,
          },
          headers: {
            organization: userOrganization?.org_id,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);

      // Safely access nested error data
      const errorData =
        error?.response?.data || error?.message || "Something went wrong";

      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const fetchHCCConditionCompliance = createAsyncThunk(
  "sensorData/fetchHCCConditionCompliance",
  async (
    {
      userOrganization,
      categoryId,
      ordering,
      page = 1,
      pageSize = 10,
      startDate,
      endDate,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(
      `/v1/meat/condition-analysis/hcc-condition-compliance/${categoryId}/`,
      {
        params: {
          ordering: ordering,
          page: page,
          page_size: pageSize,
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
export const fetchHCCCategories = createAsyncThunk(
  "sensorData/fetchHCCCategories",
  async ({ userOrganization, page = 1, pageSize = 10, search }, thunkAPI) => {
    try {
      const response = await apiRequest.get(`/v1/hcc-categories/`, {
        params: {
          page: page,
          page_size: pageSize,
          search: search,
        },
        headers: {
          organization: userOrganization?.org_id,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching HCC Categories:", error);
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const progressNotesUploadLatest = createAsyncThunk(
  "sensorData/progressNotesUploadLatest",
  async ({ userOrganization }, thunkAPI) => {
    try {
      const response = await apiRequest.get(
        `/v1/progress-notes/upload/aggregated/`,
        {
          headers: {
            organization: userOrganization?.org_id,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching latest uploads:", error);
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchProgressNotesUpload = createAsyncThunk(
  "sensorData/fetchProgressNotesUpload",
  async ({ userOrganization, page = 1, pageSize = 10, ordering }, thunkAPI) => {
    try {
      const response = await apiRequest.get(`/v1/progress-notes/upload/`, {
        params: {
          page: page,
          page_size: pageSize,
          ordering: ordering,
        },
        headers: {
          organization: userOrganization?.org_id,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching Progress notes upload:", error);
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const submitAnalysisFeedback = createAsyncThunk(
  "analysis/submitAnalysisFeedback",
  async (
    { userOrganization, analysis_id, condition, feedback_type, feedback },
    thunkAPI
  ) => {
    try {
      const response = await apiRequest.post(
        `/v1/progress-notes/meat/${analysis_id}/condition-analysis-feedback/`,
        {
          condition,
          feedback_type,
          feedback,
        },
        {
          headers: {
            organization: userOrganization?.org_id,
          },
        }
      );
      return {
        data: response.data,
        condition,
      };
    } catch (error) {
      console.error("Error Submitting Feedback:", error);
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);
export const fetchHccPeContradictionSummary = createAsyncThunk(
  "sensorData/fetchHccPeContradictionSummary",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/compliance/contradiction/summary/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchNonCompliantHCCConditions = createAsyncThunk(
  "sensorData/nonCompliantHCCConditions",
  async ({ startDate, endDate, sensorFamily, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/analytics/non-compliant-hccs/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          sensor_family: sensorFamily,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchNonCompliantHCCCategories = createAsyncThunk(
  "sensorData/nonCompliantHCCCategories",
  async (
    { startDate, endDate, sensorFamily, limit, userOrganization },
    thunkAPI
  ) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/analytics/non-compliant-hcc-categories/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          sensor_family: sensorFamily,
          limit: limit,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchContradictionProviderReport = createAsyncThunk(
  "sensorData/contradictionProviderReport",
  async (
    {
      startDate,
      endDate,
      userOrganization,
      page,
      pageSize,
      rendering_provider,
      clinic,
      search,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(
      `/v1/compliance/contradiction/provider-report/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          page: page,
          page_size: pageSize,
          search: search,
          rendering_provider: rendering_provider,
          clinic: clinic,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchProgressNoteListing = createAsyncThunk(
  "sensorData/fetchProgressNoteListing",
  async (
    {
      startDate,
      endDate,
      patient,
      rendering_provider,
      rendering_provider_group,
      rendering_provider_region,
      rendering_provider_clinic,
      sensor_compliance_status,
      is_compliant,
      is_reviewed,
      overall_compliance,
      all_sensor_families_executed,
      is_diagnostic_state_applicable,
      is_meat_applicable,
      is_buddy_coding_applicable,
      is_pending_signature_applicable,
      is_contradiction_detection_applicable,
      is_contradiction_found,
      manual_review_needed,
      diagnosis,
      agreement_status,
      ordering,
      userOrganization,
      page,
      pageSize,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/progress-notes/analysis/`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        patient: patient,
        rendering_provider: rendering_provider,
        sensor_compliance_status: sensor_compliance_status,
        rendering_provider_group: rendering_provider_group,
        rendering_provider_region: rendering_provider_region,
        rendering_provider_clinic: rendering_provider_clinic,
        is_compliant: is_compliant,
        is_reviewed: is_reviewed,
        overall_compliance: overall_compliance,
        all_sensor_families_executed: all_sensor_families_executed,
        is_diagnostic_state_applicable: is_diagnostic_state_applicable,
        is_meat_applicable: is_meat_applicable,
        is_buddy_coding_applicable: is_buddy_coding_applicable,
        is_pending_signature_applicable: is_pending_signature_applicable,
        is_contradiction_detection_applicable:
          is_contradiction_detection_applicable,
        is_contradiction_found: is_contradiction_found,
        manual_review_needed: manual_review_needed,
        agreement_status: agreement_status,
        diagnosis: diagnosis,
        ordering: ordering,
        page: page,
        page_size: pageSize,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchProgressNoteDetail = createAsyncThunk(
  "sensorData/fetchProgressNoteDetail",
  async ({ progressNoteId, userOrganization }, thunkAPI) => {
    try {
      const response = await apiRequest.get(
        `/v1/progress-notes/${progressNoteId}`,
        {
          headers: {
            organization: userOrganization.org_id,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching detail:", error);
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchHccPENoteAnalysisDetails = createAsyncThunk(
  "sensorData/fetchHccPENoteAnalysisDetails",
  async ({ progressNoteId, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/${progressNoteId}/contradiction-detection-analysis`,
      {
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchBuddyCodingSummary = createAsyncThunk(
  "sensorData/fetchBuddyCodingSummary",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/compliance/buddy-coding/summary/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchMissedBuddyCodingOpportunity = createAsyncThunk(
  "sensorData/fetchMissedBuddyCodingOpportunity",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    try {
      const response = await apiRequest.get(
        `/v1/progress-notes/analytics/buddy-coding-opportunities`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
          },
          headers: {
            organization: userOrganization.org_id,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching detail:", error);
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchBuddyCodingProviderReport = createAsyncThunk(
  "sensorData/fetchBuddyCodingProviderReport",
  async (
    {
      startDate,
      endDate,
      userOrganization,
      page,
      pageSize,
      rendering_provider,
      clinic,
      search,
    },
    thunkAPI
  ) => {
    try {
      const response = await apiRequest.get(
        `/v1/compliance/buddy-coding/provider-report/`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
            page: page,
            page_size: pageSize,
            search: search,
            rendering_provider: rendering_provider,
            clinic: clinic,
          },
          headers: {
            organization: userOrganization.org_id,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching detail:", error);
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchBuddyCodeAnalysisDetails = createAsyncThunk(
  "sensorData/BuddyCodeAnalysisDetails",
  async ({ progressNoteId, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/${progressNoteId}/buddy-coding-analysis`,
      {
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchDiagnosticStateSummary = createAsyncThunk(
  "diagnosticState/fetchSummary",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    try {
      const response = await apiRequest.get(
        `/v1/compliance/diagnostic-state/summary/`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
          },
          headers: {
            organization: userOrganization.org_id,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      throw thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const fetchDiagnosticStateTrends = createAsyncThunk(
  "diagnosticState/fetchDiagnosticStateTrend",
  async (
    { startDate, endDate, diagnostic_state, userOrganization },
    thunkAPI
  ) => {
    try {
      // Convert array to comma-separated string, excluding 'All'
      const diagnosticStateParam =
        diagnostic_state && Array.isArray(diagnostic_state)
          ? diagnostic_state.filter((state) => state !== "All").join(",")
          : undefined;

      // Build params object conditionally
      const params = {
        start_date: startDate,
        end_date: endDate,
        time_unit: "MONTH",
      };

      // Only add diagnostic_state if it has a value
      if (diagnosticStateParam) {
        params.diagnostic_state = diagnosticStateParam;
      }

      const response = await apiRequest.get(
        `/v1/compliance/diagnostic-state/trend/`,
        {
          params: params,
          headers: {
            organization: userOrganization.org_id,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      throw thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const fetchDiagnosticStateCompliance = createAsyncThunk(
  "diagnosticState/fetchDiagnosticStateCompliance",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    try {
      const response = await apiRequest.get(
        `/v1/compliance/diagnostic-state/compliance/`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
          },
          headers: {
            organization: userOrganization.org_id,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      throw thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const fetchDiagnosticStateClinicianComplianceReport = createAsyncThunk(
  "diagnosticState/fetchDiagnosticStateClinicianComplianceReport",
  async (
    {
      startDate,
      endDate,
      userOrganization,
      page,
      pageSize,
      rendering_provider,
      clinic,
      search,
    },
    thunkAPI
  ) => {
    try {
      const response = await apiRequest.get(
        `/v1/compliance/diagnostic-state/provider-report/`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
            page: page,
            page_size: pageSize,
            search: search,
            rendering_provider: rendering_provider,
            clinic: clinic,
          },
          headers: {
            organization: userOrganization.org_id,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      throw thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const fetchDiagnosticStateProgressNoteDetail = createAsyncThunk(
  "sensorData/fetchDiagnosticStateProgressNoteDetail",
  async ({ progressNoteId, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/${progressNoteId}/diagnostic-state-analysis/`,
      {
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchPendingSignatureSummary = createAsyncThunk(
  "sensorData/fetchPendingSignatureSummary",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/compliance/pending-signature/summary/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchPendingSignatureCompliance = createAsyncThunk(
  "sensorData/fetchPendingSignatureCompliance",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(`/v1/compliance/pending-signature/`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchOverallStats = createAsyncThunk(
  "sensorData/fetchOverallStats",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/analytics/summary`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchPendingSignatureProviderReport = createAsyncThunk(
  "sensorData/fetchPendingSignatureProviderReport",
  async (
    {
      startDate,
      endDate,
      page,
      pageSize,
      ordering,
      rendering_provider,
      userOrganization,
      clinic,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(
      `/v1/compliance/pending-signature/provider-report/`,
      {
        params: {
          page: page,
          page_size: pageSize,
          start_date: startDate,
          end_date: endDate,
          ordering: ordering,
          rendering_provider: rendering_provider,
          clinic: clinic,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchOverallComplianceTrends = createAsyncThunk(
  "sensorData/fetchOverallComplianceTrends",
  async ({ startDate, endDate, userOrganization, time_unit }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/analytics/compliance-trends/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          time_unit: time_unit,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchNonCompliantClinicianStats = createAsyncThunk(
  "sensorData/fetchNonCompliantClinicianStats",
  async (
    { startDate, endDate, page, pageSize, ordering, userOrganization },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/provider-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
export const fetchCompliantClinicianStats = createAsyncThunk(
  "sensorData/fetchCompliantClinicianStats",
  async (
    {
      startDate,
      endDate,
      page,
      pageSize,
      ordering,
      region,
      clinic,
      rendering_provider,
      userOrganization,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/provider-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
        region_id: region,
        clinic_id: clinic,
        rendering_provider: rendering_provider,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchNonCompliantClinicStats = createAsyncThunk(
  "sensorData/fetchNonCompliantClinicStats",
  async (
    { startDate, endDate, page, pageSize, ordering, userOrganization },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/clinic-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchCompliantClinicStats = createAsyncThunk(
  "sensorData/fetchCompliantClinicStats",
  async (
    { startDate, endDate, page, pageSize, ordering, clinic, userOrganization },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/clinic-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
        clinic_id: clinic,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchCompliantRegionStats = createAsyncThunk(
  "sensorData/fetchCompliantRegionStats",
  async (
    { startDate, endDate, page, pageSize, ordering, region, userOrganization },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/region-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
        region_id: region,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchNonCompliantRegionStats = createAsyncThunk(
  "sensorData/fetchNonCompliantRegionStats",
  async (
    { startDate, endDate, page, pageSize, ordering, userOrganization },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/region-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchClinicProviderStats = createAsyncThunk(
  "sensorData/fetchClinicProviderStats",
  async (
    {
      startDate,
      endDate,
      page,
      pageSize,
      ordering,
      clinic_id,
      rendering_provider,
      userOrganization,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/provider-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
        rendering_provider: rendering_provider,
        clinic_id: clinic_id,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchRegionProviderStats = createAsyncThunk(
  "sensorData/fetchRegionProviderStats",
  async (
    {
      startDate,
      endDate,
      page,
      pageSize,
      ordering,
      rendering_provider,
      region_id,
      userOrganization,
    },
    thunkAPI
  ) => {
    const response = await apiRequest.get(`/v1/compliance/provider-stats/`, {
      params: {
        page: page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        order_by: ordering,
        rendering_provider: rendering_provider,
        region_id: region_id,
      },
      headers: {
        organization: userOrganization.org_id,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchMEATNonComplianceTrends = createAsyncThunk(
  "sensorData/fetchMEATNonComplianceTrends",
  async ({ startDate, endDate, userOrganization }, thunkAPI) => {
    const response = await apiRequest.get(
      `/v1/progress-notes/analytics/meat-non-compliance-trends`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchBuddyCodeSuggestionTrends = createAsyncThunk(
  "sensorData/fetchBuddyCodeSuggestionTrends",
  async ({ startDate, endDate, userOrganization, time_unit }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/compliance/buddy-coding/suggestions-trend`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          time_unit: time_unit,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);

export const fetchClinics = createAsyncThunk(
  "sensorData/fetchClinics",
  async ({ userOrganization, page = 1, pageSize = 10, search }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/progress-notes/rendering-providers/clinic/`,
      {
        params: {
          page: page,
          page_size: pageSize,
          search: search,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
export const fetchRegions = createAsyncThunk(
  "sensorData/fetchRegions",
  async ({ userOrganization, page = 1, pageSize = 10, search }, thunkAPI) => {
    const response = await apiRequest.get(
      `v1/progress-notes/rendering-providers/region`,
      {
        params: {
          page: page,
          page_size: pageSize,
          search: search,
        },
        headers: {
          organization: userOrganization.org_id,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw thunkAPI.rejectWithValue(response.response.data);
  }
);
